<template>
	<div class="merchandise container-fluid py-3">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="!isChildRoute">
			<div class="col-md-12 mb-2">
				<h4>OVERVIEW MERCHANDISE</h4>
			</div>

			<div class="col-md-12">
				<div class="row">
					<div class="col-md-8">
						<div class="card cardptpr mb-4">
							<div class="card-header cardptpr p-3 pb-0 pt-0">
								<H6>SALES MERCHANDISE MY PERTAMINA (YTD {{ this.tahun }})</H6>
							</div>
							<div class="card-body p-3 pt-0" style="width:100%;">
								<BarChart v-loading.body="loading.barchart" :data="barchartdata" :width="500" :height="380"  />
							</div>
						</div>
                    </div>
					<div class="col-md-4">
						<div class="card cardptpr mb-4">
							<div class="card-header cardptpr p-3 pb-0 pt-0">
								<H6>SALES MERCHANDISE MY PERTAMINA YTD {{ this.tahun }} (Based on Delivery Type)</H6>
							</div>
							<div class="card-body p-3 pt-0" style="width:90%;">
								<PieChart v-loading.body="loading.piechart" :data="piechartdata"
									:url="''"/>
							</div>
						</div>
                    </div>
				</div>

				<div class="row">
					<div class="col-md-6 mb-4">
						<ListItem class=" mb-4" :title="'TOP 10 BEST SELLING PRODUCT (YTD '+ this.tahun + ')' " :data="bestsellingproduct" itemcol="itemname" valuecol="qty"
							url=""/>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import Basic from '@/components/page/Basic.js'
import Footer from '@/views/Footer.vue'
import { Rainbow, Rainbow2, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import PieChart from '@/components/chart/Pie.js'
import ListItem from '@/views/pages/ListItem.vue'

export default{
	extends: Basic,
	components:{
		PieChart,
		BarChart,
		ListItem,
	},
	data() {
		return {
			pldate: this.$route.query.pldate ? this.$route.query.pldate : null,
			urlRequestParams: '',
			barchartdata: [],
			piechartdata: [],
			bestsellingproduct: [],
			dateRange: [Penanggalan().tahunSekarang, Penanggalan().kemarin],
			tahun: Penanggalan().tahun,
			period: '',
			loading: {
				barchart: false,
				piechart: false,
			},
            isChildRoute: false,
		}
	},
    mounted(){
        this.hideNonChildren();
		this.getBarchart()
		this.getPiechart()
		this.topSales()
    },
    watch: {
        $route(to, from) {
            this.hideNonChildren();
        }
    },
    methods:{
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/merchandise';
        },
		getBarchart(){
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/merchandise/sales-barchart?'

			this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			this.urlRequestParams+='&date-range-end='+ this.dateRange[1]
			this.urlRequestParams+='&period='+this.period

			this.loading.barchart = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{
				let chartresponsedata = response.data.data;
				this.barchartdata = this.processBarChart(chartresponsedata, "legend", "", "price", false, "period", "", 1, 2, Rainbow, false, false, false, this.stacked);
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.barchart = false;
			})

		},

		getPiechart() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/merchandise/sales-piechart-overview?'

			this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			this.urlRequestParams+='&date-range-end='+ this.dateRange[1]
			this.urlRequestParams+='&period='+this.period

			this.loading.piechart = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{
				//this.chartresponsedata = response.data.data;
				//this.chartdata = this.processBarChart(this.chartresponsedata, "legend", "", "price", false, "period", "", 1, 2, Rainbow, false, false, false, this.stacked);

				let responsedata = response.data.data

				let item = responsedata
				var warna = []
				let value = [];
				let idx = 0;
				for (var row in item) {
					//add color
					warna[item[row].DeliveryType] = Rainbow[idx];//'#FFB22E'

					//add value
					let main = {
						transtype: item[row].DeliveryType,
						amount: item[row].qty,
					};

					value.push(main);
					idx++;
				}

				this.piechartdata = this.processPieChart(value, "amount", "transtype", 1, 2, warna);
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.piechart = false;
			})

		},
		topSales(){
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/merchandise/top-sales?'

			this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			this.urlRequestParams+='&date-range-end='+ this.dateRange[1]
			this.urlRequestParams+='&period='+this.period

			this.loading.barchart = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{
				this.bestsellingproduct = response.data.data;
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.barchart = false;
			})

		},
	}
}

</script>
